import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { TextBone } from '../../atoms/TextBone/TextBone';
import { BoxBone } from '../../atoms/BoxBone/BoxBone';

interface FieldGroupBoneProps {
    /** Afficher le label */
    showLabel?: boolean;
    /** Largeur du label */
    labelWidth?: string;
    /** Largeur du contenu */
    contentWidth?: string;
    /** Hauteur du label */
    labelHeight?: string;
    /** Hauteur du contenu */
    contentHeight?: string;
    /** Direction d'affichage */
    direction?: 'row' | 'column';
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const FieldGroupBone: React.FunctionComponent<FieldGroupBoneProps> = function ({
    showLabel = true,
    labelWidth = '20%',
    contentWidth = '40%',
    labelHeight = '32px',
    contentHeight = '48px',
    direction = 'row',
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: direction,
                alignItems: direction === 'row' ? 'center' : 'flex-start',
                gap: 1,
                width: '100%',
                ...sx,
            }}
        >
            {showLabel && <TextBone sx={{ width: labelWidth, height: labelHeight }} />}
            <BoxBone sx={{ width: contentWidth, height: contentHeight }} />
        </Box>
    );
};
